/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FunctionComponent } from "react";

/**
 * Component props
 */
export interface IRTCProps {}

/**
 * Rich text component
 */
export const RTC: FunctionComponent<IRTCProps> = ({ children }) => {
	const baseClass = BEM("edt-rtc").add("edt-base");

	return <div className={baseClass.toClassName()}>{children}</div>;
};
